'use strict'
import { App, Util } from '../../config/app.js'
import { Modal } from '../../modal.js'

export default function ()
{
	App.Modal.AddressSuggestions = new Modal('AddressSuggestions',
	{
		onInit: async (modal) =>
		{
			modal.element.addEventListener('click', e =>
			{
				if (e.target.matches('input[type=radio]'))
					modal.element.querySelector('button[type=submit]').removeAttribute('disabled')
			})
		},
		onOpen: async (modal, data) =>
		{
			if (data.id == 'SHIPPING') // NOP-504
			{
				modal.options.actionSubmitName = "addressselect modal submit"
			}
			else
			{
				modal.options.actionSubmitName = data.id ? 'address update' : 'address create'
			}

			modal.view.model.clear()
			modal.view.model.sync(data)
		},
		onActionBefore: async (modal, e) =>
		{
			let address = null;
			const original = Util.deepCopy({}, modal.view.model)
			const suggestion = parseInt(e.detail.data.suggestion) || 0
			if (suggestion < 0)
			{
				address = original
				delete address.attributes.validation
			}
			else
			{
				address = original.attributes.validation.suggestions[suggestion]
				address.id = original.id
				address.type = original.type
				address.attributes.firstName = original.attributes.firstName
				address.attributes.lastName = original.attributes.lastName
				address.attributes.email = original.attributes.email
				address.attributes.phone = original.attributes.phone
			}

			address.attributes.validate = false
			delete address.suggestion

			Util.deepCopy(e.detail.data, address);
		},
		onActionAfter: (modal, e) =>
		{
			if (e.detail?.data?.id == 'SHIPPING')
			{
				let address = App.Store.model('address', e.detail.data.id)
				address.clear()
				address.sync(e.detail.data)
			}
			else
				App.Modal.Address.close()
			modal.close()
		}
	})
}
